module.exports = __webpack_public_path__ + "img/DATE-01.afe1308e.png";